import React, { useEffect } from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";
// import "./css/base.scss";

const VetsMicroBanner = () => {
    const { clientAssetsLink } = useClientConfig();

    // FOR PROD USE ONLY - add gtm script
    // uncomment in prod version - by bhavy@eleorex.com
//     useEffect(() => {
//         // GTM Script for head
//         const gtmScript = document.createElement("script");
//         gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
// new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
// j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
// 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
// })(window,document,'script','dataLayer','GTM-PJLWL2L5');`;
//         document.head.appendChild(gtmScript);

//         // GTM noscript for body
//         const gtmNoScript = document.createElement("noscript");
//         gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PJLWL2L5"
// height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
//         document.body.insertBefore(gtmNoScript, document.body.firstChild);

//         return () => {
//             document.head.removeChild(gtmScript);
//             document.body.removeChild(gtmNoScript);
//         };
//     }, []);

    return (
        <div className="vets-micro-banner-wrapper">
            <div className="content-wrapper">
                <img src={clientAssetsLink + "/Logo-300x67.png"} alt="logo" className="logo" />
                <h1>{"JOIN AUSTRALIA & NEW ZEALAND'S leading VETERINARY Partner"}</h1>
                <p>We are looking for qualified vets like you to join our incredible network of clinics</p>
            </div>
            <img src={clientAssetsLink + "/vets-central-careers-header.jpg"} alt="Banner" />
            <div className="bg-overlay"></div>
        </div>
    );
};

export default VetsMicroBanner;